import React from 'react';
import { useTranslation } from 'yoshi-flow-editor-runtime';

export const EmptyState: React.FC = () => {
  const { t } = useTranslation();
  return <h1 data-hook="empty-state-message">{t('pp.no-plans')}</h1>;
};
